import { gql } from "@apollo/client";

export const GET_GROUP_WAGERS_WAGERPAD = gql`
  query GetGroupWagersMyBets(
    $accountId: Int!
    $startDate: String
    $endDate: String
    $wagerTypes: [String!]
    $statusList: [Status!]
  ) {
    wagerHistory(
      beginDate: $startDate
      accountId: $accountId
      endDate: $endDate
      wagerTypes: $wagerTypes
      statusList: $statusList
    ) {
      id
      groupWagersList(group: { group: RACE, order: DESC }) {
        wagerGroups {
          wagers: value {
            raceDate
            tvgRaceId
            trackName
          }
        }
      }
    }
  }
`;
